import { getRequest } from '@/utils/request';
var api = process.env['VUE_APP_AUTH_API'];
var tokenKey = 'token';
var defaultConfig = {
  baseUrl: api,
  tokenKey: tokenKey
};
/**
 * 获取用户信息
 */
export var getUserInfo = function getUserInfo() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return getRequest('/sys-client-user/get/client-user-info', {}, Object.assign({}, defaultConfig, config));
};